import { render, staticRenderFns } from "./BinnacleList.vue?vue&type=template&id=6a48b8fd&"
import script from "./BinnacleList.vue?vue&type=script&lang=js&"
export * from "./BinnacleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a48b8fd')) {
      api.createRecord('6a48b8fd', component.options)
    } else {
      api.reload('6a48b8fd', component.options)
    }
    module.hot.accept("./BinnacleList.vue?vue&type=template&id=6a48b8fd&", function () {
      api.rerender('6a48b8fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/binnacles/BinnacleList.vue"
export default component.exports